import React, { useState } from 'react';
import { IssueService } from '../../js/issues/issueService';
import { successfulAction } from '../../js/issues/IssueActionsCtrls';
import { IssueCommentProps } from '../../js/headersegment/interfaces';

const IssueComment: React.FC<IssueCommentProps> = ({
  ok,
  cancel,
  issue,
  issueUpdated,
  size,
}) => {
  const [comment, setComment] = useState<string>('');

  const handleOk = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const data = await IssueService.comment([{ id: issue.id, tripId: issue.tripId }], comment);
      if (data && successfulAction(data)) {
        issueUpdated({
          tripId: issue.tripId as string,
          issueId: issue.id!,
        });
      }
      ok();
    } catch (error) {
      console.error("Error adding comment:", error);
    }
  };

  return (
    <div
      className={`issue-resolution-modal modal-dialog modal-${size || 'md'}`}
    >
      <form name="form" noValidate onSubmit={handleOk}>
        <div className="title">
          COMMENT
          <a onClick={cancel}>
            <i
              id="modalCancelled"
              className="cancel pull-right glyphicon icon-white glyphicon-remove"
            ></i>
          </a>
        </div>

        <div className="content">
          <div className="choices">
            <div className="row">
              <div className="col-md-3 fs-label fs-label-hxs hidden-sm hidden-xs">
                COMMENT
              </div>
              <div className="col-md-3 fs-label fs-label-xs visible-sm visible-xs">
                COMMENT
              </div>
              <div className="col-md-9">
                <textarea
                  className="text-area"
                  id="comment"
                  value={comment}
                  onChange={e => setComment(e.target.value)}
                  required
                  rows={5}
                  autoFocus
                />
              </div>
            </div>
          </div>

          <div className="action">
            <button
              id="modalSubmitted"
              className="btn btn-default button-action"
              disabled={!comment}
            >
              COMMENT
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default IssueComment;
